import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { CreateServiceDefinitionReq, GetAllServiceDefinitionReq, ServiceDefinitionDto, UpdateServiceDefinitionReq } from "../../interfaces/serviceDefinition/service-definition";
import { apiDelete, apiGet, apiPost, apiPut } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";

export async function CreateServiceDefinitionAsync(
    authToken: string,
    payload: CreateServiceDefinitionReq
): Promise<ApiResponse<CreateServiceDefinitionReq>> {
    const apiUrl: string = `/service-definitions`;

    var res = apiPost<ApiResponse<CreateServiceDefinitionReq>>(
        apiUrl, payload, authToken
    )

    return res;
}



export async function GetAllServicesAsync(
    authToken: string,
    payload: GetAllServiceDefinitionReq
): Promise<ApiResponse<PagedResults<ServiceDefinitionDto>>> {
    const queryString = buildQuery(payload);
    const apiUrl: string = `/service-definitions/All?${queryString}`;

    var res = apiGet<ApiResponse<PagedResults<ServiceDefinitionDto>>>(
        apiUrl, authToken
    );

    return res;
}

export async function DeleteServiceDefinitionAsync(
    authToken: string,
    serviceDefinitionId: string
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/service-definitions/${serviceDefinitionId}`;

    var res = apiDelete<ApiResponse<boolean>>(
        apiUrl, {},authToken
    );

    return res;
}

export async function GetServiceDefinitionByIdAsync(
    authToken: string,
    serviceDefinitionId: string
): Promise<ApiResponse<ServiceDefinitionDto>> {
    const apiUrl: string = `/service-definitions/${serviceDefinitionId}`;

    var res = apiGet<ApiResponse<ServiceDefinitionDto>>(
        apiUrl, authToken
    );

    return res;
}


export async function UpdateServiceDefinitionAsync(
    authToken: string,
    payload: UpdateServiceDefinitionReq
): Promise<ApiResponse<ServiceDefinitionDto>> {
    const apiUrl: string = `/service-definitions/${payload.id}`;

    var res = apiPut<ApiResponse<ServiceDefinitionDto>>(
        apiUrl, payload, authToken
    )

    return res;
}
